module.exports = "<emi-header-banner></emi-header-banner>\r\n<app-product-listing-page [questions]=\"questions\" [pageData]=\"pageData\" [page]=\"page\" [products]=\"products\" [subcategory]=\"subCategories\"></app-product-listing-page>\r\n<emi-testimonials></emi-testimonials>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/products/product-home/product-home.component.html
// module id = 721
// module chunks = 8